import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

const EarlySubmissionModal = ({isOpen, toggle}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  SUBMISSION NOTIFICATION
                </ModalHeader>
                <ModalBody className='font-weight-bold'>
                  <h6>Dear Candidate,</h6>
                  <p>You can only end your examination 5 minutes after your start time</p>
                </ModalBody>
                <ModalFooter>
                {' '}
                <Button color='success' onClick={toggle}>
                    Okay
                </Button>
                </ModalFooter>
            </Modal>
  );
};

export default EarlySubmissionModal;
